import { render } from "./App.vue?vue&type=template&id=397e323b"
const script = {}
script.render = render

export default script